(function () {
    // Target scroll speed in pixels per second. All marquee instances on the
    // page will travel at this rate regardless of how many items they contain.
    var MARQUEE_SPEED = 80;

    function debounce(fn, wait) {
        let t;
        return function (...args) {
            window.clearTimeout(t);
            t = window.setTimeout(() => fn.apply(this, args), wait);
        };
    }

    function init_logo_marquee(viewport) {
        const track = viewport.querySelector('.block-list-track');
        const original_list = viewport.querySelector('[data-marquee-list]');

        if (!viewport || !track || !original_list) {
            return;
        }

        function remove_clones() {
            const clones = track.querySelectorAll('ul[data-marquee-clone="true"]');
            clones.forEach((clone) => clone.remove());
        }

        function set_scrolling_state(is_scrolling) {
            viewport.classList.toggle('is-scrolling', is_scrolling);
        }

        function build() {
            remove_clones();

            const reduce_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduce_motion) {
                set_scrolling_state(false);
                return;
            }

            const viewport_width = viewport.clientWidth;

            const prev_animation = track.style.animation;
            track.style.animation = 'none';

            const list_width = original_list.scrollWidth;

            track.style.animation = prev_animation;

            if (list_width <= viewport_width) {
                set_scrolling_state(false);
                return;
            }

            set_scrolling_state(true);

            const min_track_width = Math.max(list_width * 2, viewport_width * 2);
            let current_width = list_width;

            while (current_width < min_track_width) {
                const clone = original_list.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                clone.setAttribute('data-marquee-clone', 'true');

                track.appendChild(clone);
                current_width += list_width;
            }

            // The animation always moves the track by -50% of its total width.
            // Derive the duration from that distance so every marquee scrolls at
            // the same pixel-per-second speed, regardless of item count.
            const distance = track.scrollWidth * 0.5;
            const duration = (distance / MARQUEE_SPEED).toFixed(2);
            viewport.style.setProperty('--news-scroll-duration', `${duration}s`);
        }

        const rebuild = debounce(build, 150);

        window.addEventListener('resize', rebuild, { passive: true });

        const imgs = original_list.querySelectorAll('img');
        imgs.forEach((img) => {
            if (!img.complete) {
                img.addEventListener('load', rebuild, { passive: true });
                img.addEventListener('error', rebuild, { passive: true });
            }
        });

        build();
        requestAnimationFrame(build);
    }

    function init_all() {
        const marquees = document.querySelectorAll('[data-marquee]');
        marquees.forEach(init_logo_marquee);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init_all);
    } else {
        init_all();
    }
})();
